import { ClassNames } from '@emotion/core';
import React from 'react';
import Youtube from 'react-youtube';

type Props = {
  videoId: string;
};

export const YoutubeVideo = ({ videoId }: Props) => {
  return (
    <ClassNames>
      {({ css }) => (
        <div>
          <Youtube
            videoId={videoId}
            containerClassName={css`
              position: relative;
              width: 100%;
              margin-bottom: 50px;
            `}
          />
        </div>
      )}
    </ClassNames>
  );
};
